import { HTTP_STATUS_NOT_FOUND } from '../../../constants/api'
import { EMPTY_OBJECT } from '../../../constants/common'
import { EMAIL_MESSAGE_PROFILE_ACTION_SERVICE_REQUESTS_OPTIONS } from '../Email.constants'
import { getEmailProfileActionsWidgetItems } from '../EmailProfile'
import { EmailProfileActionsWidgetServiceRequestButton } from '../EmailProfileWidget'

export function getEmailMessageProfileData(response) {
  const item = response?.data?.items[0]

  if (response && !item) {
    throw Object.assign(new Error('Email message not found'), {
      response: { status: HTTP_STATUS_NOT_FOUND },
    })
  }

  return { data: item ?? null }
}

export function getEmailMessageProfileNextUpdatedData(prevData, data) {
  // #INFO Add necessary properties after updating profile
  return {
    ...prevData,
    soft_archived: data.soft_archived,
    starred: data.starred,
  }
}

export function getMessages(entityData) {
  return entityData ? [entityData] : null
}

export function getEmailMessageProfileActionsWidgetItems({
  entityData,
  sub,
  t,
  widgetsData,
}) {
  const { permissions = EMPTY_OBJECT } = entityData || EMPTY_OBJECT

  const shouldRenderRequestsActionsButton =
    permissions.can_create_request || permissions.can_attach_to_request

  const requestsActionsButton = {
    Component: EmailProfileActionsWidgetServiceRequestButton,
    value: EMAIL_MESSAGE_PROFILE_ACTION_SERVICE_REQUESTS_OPTIONS,
  }

  const items = getEmailProfileActionsWidgetItems({
    entityData,
    sub,
    t,
    widgetsData,
  })

  return shouldRenderRequestsActionsButton
    ? items.toSpliced(2, 0, requestsActionsButton)
    : items
}
